export default __webpack_public_path__ + "static/media/furnished-property.805eda1d.svg";